module.exports = __webpack_public_path__ + "static/media/femme-actuelle.5a4323d2.png";